import { render, staticRenderFns } from "./FabBtn.vue?vue&type=template&id=092ec24f&scoped=true"
import script from "./FabBtn.vue?vue&type=script&lang=js"
export * from "./FabBtn.vue?vue&type=script&lang=js"
import style0 from "./FabBtn.vue?vue&type=style&index=0&id=092ec24f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092ec24f",
  null
  
)

export default component.exports